import React, { useEffect, useState } from 'react'
import DataTableComponent from '../../common/data-table-component/data-table-component'
import axios from '../../../api/axios';
import { Badge, Box, Button, CircularProgress, IconButton, Input, TextField } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CommonModel from '../../Models/common-model';
import Cookies from 'universal-cookie';
import { Configurations } from '../../../config';
import WifiUserModel from '../../Models/wifi-user-model';
import AddWifiUserModel from '../../Models/add-wifi-user-model';

export default function USJNetWiFiMembersComponent() {

  const [rowData, setRowData] = useState([]);
  const [rowDataTemp, setRowDataTemp] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
const [emailCreateData,setEmailCreateData] = useState([]);
const [emailCreateDataTemp,setEmailCreateDataTemp] = useState([]);
const [modelViewData, setModelViewData] = useState([]);
const [isModelOpen,setIsModelOpen] = useState(false);
const [isAddUserModelOpen,setIsAddUserModelOpen] = useState(false);
const [searchText, setSearchText] = useState("");
const [quickApplyloading, setQuickApplyLoading] = useState(false);
const [departmentList,setDepartmentList] = useState([]);
const [facultyList,setFacultyList] = useState([]);

useEffect(()=>{

  setIsLoading(true);
  getWiFiUsers();
},[]);



const getWiFiUsers = () => {
  axios.get("/wifi/users")
      .then(async function (response) {
        if(response.status === 200){
            setEmailCreateData(response.data);
            setEmailCreateDataTemp(response.data);
            setIsLoading(false);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
}

const getDepartmentFacultyWise = (facultyId) => {
  axios.get("/departments")
      .then(async function (response) {
        if(response.status === 200){
            setEmailCreateData(response.data);
            setEmailCreateDataTemp(response.data);
            setIsLoading(false);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
}

const getFaculties = () => {
  axios.get("/faculty")
      .then(async function (response) {
        if(response.status === 200){
            setEmailCreateData(response.data);
            setEmailCreateDataTemp(response.data);
            setIsLoading(false);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
}


const reLogAccount = (email) => {
  setIsLoading(true);
  axios.post("/user/re-log",{email:email})
      .then(async function (response) {
        if(response.status === 200){
            var username = response.data?.un;
            var password = response.data?.pw;
           // const newWindow2 = window.open(`https://usjnetsso.sjp.ac.lk/sso/ul/api?window=new&username=${username}&password=${password}`, '_blank', 'width=800,height=600,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no');
            const newWindow =  window.open(
              `https://usjnetsso.sjp.ac.lk/sso/ul/api?4a931fa868fc449aa89f74b5c2532d1e=4a931fa868fc449aa89f74b5c2532d1e&username=${username}&password=${password}`,
              'popupWindow',
              'width=600,height=500,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=no'
            );
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
}



const handleSubmitUserUpdate = (submitData) => {
  setIsLoading(true);
  console.log(submitData);
  axios.post("/wifi/users/update",submitData)
      .then(async function (response) {
        if(response.status === 200 && response.data.state == "success"){
            getWiFiUsers();
            alert("updated");
            setIsLoading(false);
        }else{
          getWiFiUsers();
          alert("Error");
            setIsLoading(false);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
}

const handleSubmitAddWifiUser = (submitData) => {
  setIsLoading(true);
    axios.post("/wifi/users", submitData)
    .then(async function (response) {
      if (response.status === 200 && response.data.state === "success") {
        getWiFiUsers();
        alert("User created successfully.");
        setIsAddUserModelOpen(false);
      } else {
        getWiFiUsers();
        alert("Error");
       // setIsAddUserModelOpen(false);
      }
      setIsLoading(false);
    })
    .catch(function (error) {
      setIsLoading(false);

      if (error.response && error.response.status === 409) {
        alert("User Already Exist");
        setIsAddUserModelOpen(false);
      } else {
        console.error(error);
        alert("Something went wrong!");
      }
    });

}

    const columns = [
    { id: 'id', label: 'ID', minWidth: 10 },
    { id: 'nic', label: 'NIC', minWidth: 80 },
    { id: 'name', label: 'Name', minWidth: 100 },
    { id: 'mobileNo', label: 'Mobile No', minWidth: 50 },
    { id: 'wifiState', label: 'Status', minWidth: 70 },
    { id: 'wifiKey', label: 'Wi-Fi Password', minWidth: 50 },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'center',
        
    },
    
  ];

    useEffect(()=>{
      var res = emailCreateData.map((val,index)=>({
          id : index+1,
          name: val.initials+ " " + " " + val.lName ,
          nic: val?.nic,
          mobileNo:val?.mobile,
          wifiKey: val?.wifiKey,
          wifiState: (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {val?.flag == 0 && val?.wifiState === true ? (
               <Badge
                  color="success"
                  badgeContent="Active"
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: '0.6rem', // or any desired size
                      padding: '4px 6px', // optional: adjust padding for better fit
                    },
                  }}></Badge>
              ) : val?.flag == 0 && val?.wifiState === false ? (
               <Badge
                  color="error"
                  badgeContent="Inactive"
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: '0.6rem', // or any desired size
                      padding: '4px 6px', // optional: adjust padding for better fit
                    },
                  }}></Badge>
              ) : (
                "pending status..."
              )}
            </Box>
          ),
          action:<>
             <IconButton onClick={() => changeModelViewData(val)}>
                <SettingsOutlinedIcon />
              </IconButton>
          </>,
      }));
    setRowData(res);
    setRowDataTemp(res);

  },[emailCreateData]);

  const changeModelViewData = (val) => {
    axios.post("/wifi/user",{nic:val?.nic})
      .then(async function (response) {
        console.log(response.data,"comming data")
        if(response.status === 200){
            var data = {
              name: val.initials+ " " + " " + val.lName ,
              nic: val?.nic,
              terminateDate: response.data?.terminateEndDate,
              mobileNo: val?.mobile,
              
          };
          setModelViewData(data);
          setIsModelOpen(true);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
    
   
  }

  const handleOpenAddWiFiUserModel = () => {
    
    axios.get("/faculties")
      .then(async function (response) {
        if(response.status === 200){
          console.log(response.data)
            setFacultyList(response.data);
            setIsAddUserModelOpen(true);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
  }

  const onChangeFacultyList = (facultyId) => {
    getFilterdDeartment(facultyId);
  }

  const getFilterdDeartment = (facultyId) => {
    axios.get("/departments/"+ facultyId)
      .then(async function (response) {
        if(response.status === 200){
          console.log(response.data)
            setDepartmentList(response.data);
            setIsAddUserModelOpen(true);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
  }

  const GetFacultyList = () => {

  }

  const data = [{ id: 1, firstName: 'John', lastName: 'Doe' },{ id: 2, firstName: 'John', lastName: 'Doe' }];

   const renderRowExpanded = rowData => {
    return (
      <div>
        <div
          style={{
            width: 60,
            height: 60,
            float: 'left',
            marginRight: 10,
            background: '#eee'
          }}
        >
          <img src={rowData.avatar} style={{ width: 60 }} />
        </div>
        <p>Email: {rowData.email}</p>
        <p>Phone: {rowData.phone}</p>
      </div>
    );
  };

  const handleChangeSearch = (val) => {
    setSearchText(val.target.value);
    var searchTearm = val.target.value;
    var filteredData = [];
     filteredData = emailCreateDataTemp.filter(item =>
    item.nic.toLowerCase().includes(searchTearm.toLowerCase())
    );
    if(filteredData.length === 0){
      filteredData = emailCreateDataTemp.filter(item =>
      item.mobile.toLowerCase().includes(searchTearm.toLowerCase()))
    }
    
    setEmailCreateData(filteredData);
  }

  const triggerSilentRequest =  () => {
  try {
    setQuickApplyLoading(true);
    setTimeout(async() => {
           const response = await fetch('https://usjnetsso.sjp.ac.lk/sso/api/wifi/users/job', {
          method: 'GET'
        });
        getWiFiUsers();
        setQuickApplyLoading(false);
        }, 1000);
   
  } catch (error) {
    getWiFiUsers();
    console.error('Trigger failed:', error);
  }
};

  return (
    <>
    <div class="product__discount">
        <div class="section-title product__discount__title">
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <h2 style={{ margin: 0 }}>USJNet Wi-Fi Only Members</h2>
            <Button variant="contained" style={{backgroundColor:'gray',color:'white'}} onClick={() => triggerSilentRequest()}>
              {!quickApplyloading ? "Quick apply" : <>Appling.. <CircularProgress style={{width:20,height:20,color:'white'}}/></> } </Button>

            <Button variant="contained" style={{backgroundColor:'#990000',color:'white'}} onClick={() => setIsAddUserModelOpen(true)}>
              Add Member
            </Button>
          </div> */}

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {/* Left side: Heading and Quick Apply button */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <h2 style={{ margin: 0 }}>USJNet Wi-Fi Only Members</h2>
                    
                  </div>

                  {/* Right side: Add Member button */}
                  <div style={{paddingLeft:100}}></div>
                  <Button
                      variant="contained"
                      style={{ backgroundColor: 'gray', color: 'white' }}
                      onClick={() => triggerSilentRequest()}
                    >
                      {!quickApplyloading ? (
                        'Quick Update'
                      ) : (
                        <>
                          Applying...
                          <CircularProgress style={{ width: 20, height: 20, color: 'white', marginLeft: 8 }} />
                        </>
                      )}
                    </Button>
                    
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#990000', color: 'white' }}
                    onClick={() => handleOpenAddWiFiUserModel()}
                  >
                    Add Member
                  </Button>
                </div>



            <div style={{ padding:20 }}></div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
            <div style={{ maxWidth: 400, width: '100%' }}>
              <TextField
                label="Search"
                variant="outlined" // This makes the input outlined
                value={searchText}
                onChange={(val) => handleChangeSearch(val)}
                fullWidth // Optional: to make the input take full width
              />
            </div>
          </div>
            
            <DataTableComponent columns={columns} data={rowData} />
        </div>
        
    </div>
    <WifiUserModel reLogAccount={reLogAccount} modelViewData={modelViewData} setIsModelOpen={setIsModelOpen} openModel = {isModelOpen} handleSubmitUserUpdate={handleSubmitUserUpdate}/>
    <AddWifiUserModel reLogAccount={reLogAccount} modelViewData={modelViewData} setIsModelOpen={setIsAddUserModelOpen} openModel = {isAddUserModelOpen} handleSubmitAddWifiUser={handleSubmitAddWifiUser} departmentList={departmentList} facultyList={facultyList} onChangeFacultyList={onChangeFacultyList}/>

    </>
     
  )
}
